/* OSZEA — interactions and state */
(function(){
  buildPage();

  const $ = (s,c)=>(c||document).querySelector(s);
  const $$ = (s,c)=>[...(c||document).querySelectorAll(s)];
  const money = window.money || (n => '$'+n.toLocaleString());

  /* ---------- Reveal on scroll ---------- */
  const io = new IntersectionObserver((es)=>{
    es.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  },{ threshold:0.12, rootMargin:'0px 0px -8% 0px' });
  $$('.reveal').forEach(el=>io.observe(el));

  /* ---------- Hero intro (CSS @keyframes driven; copy visible by default) ---------- */

  /* ---------- Hero slider ---------- */
  (function heroSlider(){
    const track = $('#heroTrack'); if(!track) return;
    const slides = $$('.hero-slide', track);
    const dots = $$('#heroDots .hero-dot');
    let cur = 0, timer = null; const DUR = 6000;
    function go(i){
      cur = (i + slides.length) % slides.length;
      slides.forEach((s,n)=>s.classList.toggle('active', n===cur));
      dots.forEach((d,n)=>d.classList.toggle('active', n===cur));
      arm();
    }
    function arm(){ clearTimeout(timer); timer = setTimeout(()=>go(cur+1), DUR); }
    const nx=$('#heroNext'), pv=$('#heroPrev');
    if(nx) nx.addEventListener('click', ()=>go(cur+1));
    if(pv) pv.addEventListener('click', ()=>go(cur-1));
    dots.forEach(d=>d.addEventListener('click',()=>go(+d.dataset.go)));
    const hero = $('#hero');
    if(hero){ hero.addEventListener('mouseenter', ()=>clearTimeout(timer)); hero.addEventListener('mouseleave', arm); }
    arm();
  })();

  /* ---------- Nav scroll glass ---------- */
  const navZone = $('#navZone');
  if(navZone){
    const onScroll = ()=>{ navZone.classList.toggle('scrolled', window.scrollY>40); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive:true });
  }

  /* ---------- Announcement rotator (skip if the global header already drives it) ---------- */
  if(!window.__oszeaHeaderInit){
    const msgs = $$('.announce-msg'); let mi=0;
    if(msgs.length>1) setInterval(()=>{ msgs[mi].classList.remove('active'); mi=(mi+1)%msgs.length; msgs[mi].classList.add('active'); }, 4200);
  }

  /* ---------- Currency ---------- */
  let cur = 'NZD';
  const curBtn = $('#curBtn');
  if(curBtn){
    curBtn.addEventListener('click', ()=>{
      cur = cur==='NZD'?'AUD':'NZD';
      const flag = cur==='NZD'?'🇳🇿':'🇦🇺', other = cur==='NZD'?'/ AUD':'/ NZD';
      curBtn.innerHTML = `<span class="flag">${flag}</span><span>${cur}</span><span class="label-hide" style="opacity:.5">${other}</span>`;
      toast('Prices now showing in '+cur);
    });
  }

  /* ---------- Mobile menu ---------- */
  const mmenu = $('#mmenu');
  const hamBtn = $('#hamBtn');
  if(mmenu && mmenu.parentElement !== document.body){ document.body.appendChild(mmenu); }
  if(hamBtn && mmenu) hamBtn.addEventListener('click', ()=>{ mmenu.classList.add('open'); document.body.style.overflow='hidden'; });
  if(mmenu) $$('[data-close-menu]').forEach(b=>b.addEventListener('click',()=>{ mmenu.classList.remove('open'); document.body.style.overflow=''; }));

  /* ---------- Search ---------- */
  const navSearch = $('#navSearch');
  const searchBtn = $('#searchBtn');
  const mSearchBtn = $('#mSearchBtn');
  if(searchBtn && navSearch){
    searchBtn.addEventListener('click', ()=>{ navSearch.classList.add('open'); $('#searchInput').focus(); });
    $('#searchInput').addEventListener('keydown', e=>{ if(e.key==='Escape') navSearch.classList.remove('open'); });
    document.addEventListener('click', e=>{
      if(!navSearch.classList.contains('open')) return;
      if(navSearch.contains(e.target)) return;
      if(searchBtn.contains(e.target)) return;
      if(mSearchBtn && mSearchBtn.contains(e.target)) return;
      navSearch.classList.remove('open');
    });
  }
  if(mSearchBtn && navSearch){
    mSearchBtn.addEventListener('click', ()=>{
      if(mmenu){ mmenu.classList.remove('open'); }
      document.body.style.overflow='';
      navSearch.classList.add('open');
      setTimeout(()=>{ const si=$('#searchInput'); if(si) si.focus(); }, 300);
    });
  }

  /* ---------- Toast ---------- */
  function toast(msg){
    const tz = $('#toastZone'); if(!tz) return;
    const t = document.createElement('div');
    t.className='toast';
    t.innerHTML = `<span class="tk">${svg('check','',24)}</span>${msg}`;
    tz.appendChild(t);
    requestAnimationFrame(()=>t.classList.add('show'));
    setTimeout(()=>{ t.classList.remove('show'); setTimeout(()=>t.remove(),400); }, 2600);
  }

  /* ============ FORECAST CONSOLE ============ */
  let region='nz', activeIdx=0;
  const skyStat = (label,val,alert)=>`<span class="sky-stat ${alert?'alert':''}">${label} ${val}</span>`;

  function renderGrid(){
    const list = WEATHER[region];
    $('#fcGrid').innerHTML = list.map((c,i)=>`
      <button class="city-card ${i===activeIdx?'active':''}" data-i="${i}">
        ${svg(c.key,'cc-ico',48)}
        <div><div class="cc-name">${c.city}</div><div class="cc-cond">${c.cond}</div></div>
        <div class="cc-right"><div class="cc-temp">${c.temp}°</div><div class="cc-rain ${c.rain<20?'dry':''}">${c.rain<20?'Dry':c.rain+'% rain'}</div></div>
      </button>`).join('');
    $$('#fcGrid .city-card').forEach(b=>b.addEventListener('click',()=>{ activeIdx=+b.dataset.i; renderGrid(); renderSky(); clock(); }));
  }
  function renderSky(){
    const c = WEATHER[region][activeIdx];
    const sky = $('#fcSky');
    sky.dataset.cond = c.key;
    $('#skyCity').textContent = c.city;
    $('#skyRegion').innerHTML = `<span class="rb">${region.toUpperCase()}</span> ${region==='nz'?'New Zealand':'Australia'}`;
    $('#skyTemp').innerHTML = `${c.temp}<sup>°C</sup>`;
    $('#skyCond').textContent = c.cond;
    $('#skyIco').innerHTML = svg(c.key,'sky-ico',48);
    let stats = skyStat('Rain', c.rain+'%', c.alert && c.rain>=40);
    if(c.wind) stats += skyStat('Wind', c.wind+' km/h', c.alert && !!c.wind && c.rain<40);
    $('#skyStats').innerHTML = stats;
    const pickObj = window.FORECAST_PICKS && window.FORECAST_PICKS[c.city];
    const title = pickObj ? pickObj.title : c.pick;
    const ctaText = pickObj ? pickObj.cta : c.cta;
    const url = pickObj ? pickObj.url : '#';
    const image = pickObj ? pickObj.image : null;

    $('#skyProd').textContent = title;
    
    const thumb = $('#skyThumb'); 
    if(thumb){
      if(image) {
        thumb.innerHTML = `<img src="${image}" width="${pickObj.imageWidth || 400}" height="${pickObj.imageHeight || 400}" alt="${title}" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;">`;
      } else {
        thumb.innerHTML = `<span class="ph-label">${c.thumb || c.pick}</span>`;
      }
    }
    
    const cta = $('#skyCta');
    if(cta) {
      cta.innerHTML = `${ctaText} <span class="arw">→</span>`;
      cta.href = url;
    }
  }
  function renderTicker(){
    const all = [...WEATHER.nz, ...WEATHER.au];
    const item = c => `<span class="ticker-item">${c.city} <b>${c.temp}°</b> ${c.cond}${c.rain>=40?` · <span class="rn">${c.rain}% rain</span>`:''}</span>`;
    $('#fcTicker').innerHTML = (all.map(item).join('')).repeat(2);
  }
  $$('#fcTabs .console-tab').forEach(t=>t.addEventListener('click',()=>{
    if(t.classList.contains('active')) return;
    $$('#fcTabs .console-tab').forEach(x=>x.classList.remove('active'));
    t.classList.add('active'); region=t.dataset.region; activeIdx=0;
    // tactile feedback for CRO
    t.classList.remove('pop'); void t.offsetWidth; t.classList.add('pop');
    const body=$('.console-body'); if(body){ body.classList.remove('swap'); void body.offsetWidth; body.classList.add('swap'); }
    renderGrid(); renderSky(); clock();
    toast(region==='nz' ? 'Showing New Zealand weather' : 'Showing Australia weather');
  }));
  const CLOCK_CITY = { nz:'Auckland', au:'Melbourne' };
  function clock(){
    const c = (WEATHER[region] && WEATHER[region][activeIdx]) || {};
    const tz = c.tz || (typeof REGION_TZ!=='undefined' && REGION_TZ[region]) || 'Pacific/Auckland';
    let time='';
    try { time = new Date().toLocaleTimeString('en-NZ',{ timeZone:tz, hour:'numeric', minute:'2-digit', hour12:true }); }
    catch(e){ time = new Date().toLocaleTimeString('en-NZ',{hour:'numeric',minute:'2-digit',hour12:true}); }
    const clockHtml = `${c.city || CLOCK_CITY[region]} <b>${time}</b>`;
    $('#fcClock').innerHTML = clockHtml;
    const tickerTime = $('#fcTickerTime');
    if(tickerTime) tickerTime.innerHTML = clockHtml;
  }

  /* ---- Live weather via Open-Meteo (free, no key) ---- */
  function mapCode(code, wind){
    const big = (wind||0) >= 35;
    if(code===0) return big ? { cond:'Clear & Windy', key:'windy', alert:false } : { cond:'Clear', key:'clear', alert:false };
    if(code===1) return { cond:'Mostly Clear', key:'clear', alert:false };
    if(code===2) return { cond:'Partly Cloudy', key:'partly', alert:false };
    if(code===3) return { cond:'Overcast', key:'partly', alert:false };
    if(code===45||code===48) return { cond:'Fog', key:'humid', alert:false };
    if(code>=51&&code<=57) return { cond:'Drizzle', key:'showers', alert:true };
    if(code>=61&&code<=67) return { cond:'Rain', key:'rain', alert:true };
    if(code>=71&&code<=77) return { cond:'Snow', key:'chill', alert:false };
    if(code>=80&&code<=82) return { cond:'Showers', key:'showers', alert:true };
    if(code>=85&&code<=86) return { cond:'Snow Showers', key:'chill', alert:false };
    if(code>=95) return { cond:'Thunderstorm', key:'rain', alert:true };
    return big ? { cond:'Windy', key:'windy', alert:false } : { cond:'Cloudy', key:'partly', alert:false };
  }
  async function loadLiveWeather(){
    const status = $('.console-status');
    if(status) status.innerHTML = `<span class="live"></span>Connecting to live weather…`;
    try {
      for(const reg of ['nz','au']){
        const list = WEATHER[reg];
        const lat = list.map(c=>c.lat).join(',');
        const lon = list.map(c=>c.lon).join(',');
        // === INTEGRATION POINT: Live weather (Open-Meteo) ===
        // Cities & coordinates live in js/data.js (WEATHER); clock zones in REGION_TZ.
        // NOTE: Open-Meteo's free tier is NON-COMMERCIAL. For a live store, either use
        // their commercial plan (append &apikey=YOUR_KEY and switch host to
        // customer-api.open-meteo.com) OR proxy this through your own cached endpoint
        // (recommended: cache 10–15 min server-side). See HANDOFF.md → "Weather API".
        const url = `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&current=temperature_2m,weather_code,wind_speed_10m&hourly=precipitation_probability&forecast_days=1&timezone=auto`;
        const res = await fetch(url);
        if(!res.ok) throw new Error('http '+res.status);
        const data = await res.json();
        const arr = Array.isArray(data) ? data : [data];
        arr.forEach((d,i)=>{
          const c = list[i]; if(!c || !d.current) return;
          c.temp = Math.round(d.current.temperature_2m);
          c.wind = Math.round(d.current.wind_speed_10m);
          const m = mapCode(d.current.weather_code, c.wind);
          c.cond = m.cond; c.key = m.key;
          let rain = 0;
          if(d.hourly && d.hourly.precipitation_probability && d.hourly.time){
            const hr = (d.current.time||'').slice(0,13);
            let idx = d.hourly.time.findIndex(tt=>tt.slice(0,13)===hr);
            if(idx<0) idx=0;
            rain = d.hourly.precipitation_probability[idx];
            if(rain==null) rain=0;
          }
          c.rain = rain;
          c.alert = rain>=50 || m.alert;
        });
      }
      if(status) status.innerHTML = `<span class="live"></span>Live weather · Open-Meteo · updated just now`;
      renderGrid(); renderSky(); renderTicker();
    } catch(e){
      if(status) status.innerHTML = `<span class="live"></span>Live weather · showing sample data`;
    }
  }
  renderGrid(); renderSky(); renderTicker(); clock(); setInterval(clock, 10000);
  loadLiveWeather();

  /* ============ TECH layer hover/tap sync (bright preview) ============ */
  (function techLayers(){
    function setHot(i){
      $$('.tech-layer').forEach(l=>l.classList.toggle('hot', +l.dataset.layer===i));
      $$('.tech-hotspot').forEach(s=>s.classList.toggle('hot', +s.dataset.layer===i));
      $$('.tech-img').forEach(img=>img.classList.toggle('hot', +img.dataset.layer===i));
    }
    document.addEventListener('mouseover', e => {
      const el = e.target.closest('.tech-layer, .tech-hotspot');
      if(el && el.dataset.layer !== undefined) setHot(+el.dataset.layer);
    });
    document.addEventListener('click', e => {
      const el = e.target.closest('.tech-layer, .tech-hotspot');
      if(el && el.dataset.layer !== undefined) setHot(+el.dataset.layer);
    });
  })();

  /* ============ WHY parallax + reveal ============ */
  (function whyParallax(){
    const stage = $('#whyStage'); if(!stage) return;
    const img = $('.why-bg .ph', stage); if(!img) return;
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    stage.addEventListener('pointermove', e=>{
      const r = stage.getBoundingClientRect();
      const dx = (e.clientX - r.left)/r.width - 0.5;
      const dy = (e.clientY - r.top)/r.height - 0.5;
      img.style.transform = `scale(1.07) translate(${dx*-16}px, ${dy*-16}px)`;
    });
    stage.addEventListener('pointerleave', ()=>{ img.style.transform = ''; });
  })();

  /* ============ WHY rows scroll highlight ============ */
  const whyRows = $$('.why-row');
  const whyIo = new IntersectionObserver((es)=>{
    es.forEach(e=>e.target.classList.toggle('lit', e.isIntersecting && e.intersectionRatio>0.6));
  },{ threshold:[0,0.6,1] });
  whyRows.forEach(r=>whyIo.observe(r));

  /* ============ MAP (optional) ============ */
  const mapCanvasEl = $('#mapCanvas');
  if(mapCanvasEl){
  const tip = $('#mapTip');
  function showTip(i){
    const p = MAP_PINS[i];
    tip.innerHTML = `<div class="mt-top">${svg('pin','mt-ico',24)} ${p.city}</div><div class="mt-cond">${p.cond}</div><div class="mt-prod">${p.prod}</div><div class="mt-quote">"${p.quote}"</div>`;
    tip.style.left = p.x+'%'; tip.style.top = p.y+'%';
    tip.classList.add('show');
    $$('.pin').forEach(pn=>pn.classList.toggle('active', +pn.dataset.pin===i));
    $$('.rail-card').forEach(rc=>rc.classList.toggle('active', +rc.dataset.pin===i));
  }
  $$('.pin').forEach(pn=>{
    pn.addEventListener('mouseenter',()=>showTip(+pn.dataset.pin));
    pn.addEventListener('click',()=>showTip(+pn.dataset.pin));
  });
  mapCanvasEl.addEventListener('mouseleave',()=>{ tip.classList.remove('show'); $$('.pin').forEach(p=>p.classList.remove('active')); });
  $$('.rail-card').forEach(rc=>{
    rc.addEventListener('mouseenter',()=>showTip(+rc.dataset.pin));
    rc.addEventListener('click',()=>{ showTip(+rc.dataset.pin); });
  });
  }

  /* ============ PERSONAS spotlight ============ */
  (function personas(){
    const stage = $('#psSpotlight'); if(!stage) return;
    const slides = $$('.ps-slide');
    const chips = $$('.ps-chip');
    const prog = $('#psProgress');
    const idxEl = $('#psIndex');
    const marquee = $('#psList');
    let cur=0, timer=null, paused=false; const DUR=4200;
    function paint(){
      slides.forEach((s,n)=>s.classList.toggle('active', n===cur));
      chips.forEach(c=>c.classList.toggle('active', +c.dataset.ps===cur));
      if(idxEl) idxEl.textContent = String(cur+1).padStart(2,'0');
    }
    function arm(){
      clearTimeout(timer);
      if(prog){ prog.style.transition='none'; prog.style.width='0%'; void prog.offsetWidth; }
      if(paused) return;
      if(prog){ prog.style.transition=`width ${DUR}ms linear`; prog.style.width='100%'; }
      timer=setTimeout(()=>{ cur=(cur+1)%slides.length; paint(); arm(); }, DUR);
    }
    function go(i){ cur=(i+slides.length)%slides.length; paint(); arm(); }
    chips.forEach(c=>c.addEventListener('click',()=>go(+c.dataset.ps)));
    [stage, marquee].forEach(el=>{
      if(!el) return;
      el.addEventListener('mouseenter',()=>{ paused=true; clearTimeout(timer); if(prog){ const w=getComputedStyle(prog).width; prog.style.transition='none'; prog.style.width=w; } });
      el.addEventListener('mouseleave',()=>{ paused=false; arm(); });
    });
    paint(); arm();
  })();

  /* ============ RAINCLUB ============ */
  (function rainclub(){
    const chips = $$('#rcChips .rc-chip');
    chips.forEach(c=>c.addEventListener('click',()=>c.classList.toggle('on')));
    const form = $('.js-rcjoin');
    if(form){
      form.addEventListener('submit',e=>{
        e.preventDefault();
        const input=$('input',form); const v=input.value.trim();
        if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)){ input.style.outline='2px solid var(--orange)'; input.focus(); return; }
        input.style.outline='none';
        const picked=chips.filter(c=>c.classList.contains('on')).map(c=>c.dataset.int);
        const sd=$('#rcSuccessD');
        if(sd && picked.length){
          const list = picked.length>2 ? picked.slice(0,2).join(', ')+' + more' : picked.join(' & ');
          sd.textContent = `We'll tune your drops around ${list}. 10% off is on its way to your inbox.`;
        }
        const shell=$('.rc-shell'); if(shell) shell.classList.add('joined');
        const su=$('#rcSuccess'); if(su) su.setAttribute('aria-hidden','false');
        toast('Welcome to the RainClub ☔');
      });
    }
    const cnt=$('#rcCount');
    if(cnt){
      const target=24182;
      const io=new IntersectionObserver((es)=>{
        es.forEach(en=>{
          if(!en.isIntersecting) return;
          let n=target-2400;
          const t=setInterval(()=>{ n+=Math.ceil((target-n)/7); if(n>=target){ n=target; clearInterval(t); } cnt.textContent=n.toLocaleString(); }, 45);
          io.disconnect();
        });
      },{ threshold:.4 });
      io.observe(cnt);
    }
  })();

  /* ============ HEALTHCARE VERIFY ============ */
  (function verify(){
    const modal=$('#verify'); if(!modal) return;
    const form=$('#verifyForm'), success=$('#verifySuccess');
    let country='NZ';
    function reset(){
      if(form){ form.style.display=''; form.reset(); }
      $$('#vfCountry button').forEach((x,i)=>x.classList.toggle('active', i===0)); country='NZ';
      const s=$('.vf-submit'); if(s){ s.classList.remove('loading'); s.innerHTML='Verify Eligibility <span class="arw">→</span>'; }
      if(success){ success.setAttribute('aria-hidden','true'); success.classList.remove('show'); }
    }
    const open=()=>{ modal.classList.add('open'); modal.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; };
    const close=()=>{ modal.classList.remove('open'); modal.setAttribute('aria-hidden','true'); document.body.style.overflow=''; setTimeout(reset, 360); };
    const btn=$('#rcNurseBtn'); if(btn) btn.addEventListener('click', open);
    $$('[data-close-verify]').forEach(b=>b.addEventListener('click', close));
    document.addEventListener('keydown', e=>{ if(e.key==='Escape' && modal.classList.contains('open')) close(); });
    $$('#vfCountry button').forEach(b=>b.addEventListener('click',()=>{
      $$('#vfCountry button').forEach(x=>x.classList.remove('active')); b.classList.add('active'); country=b.dataset.c;
    }));
    if(form) form.addEventListener('submit',e=>{
      e.preventDefault();
      const email=$('#vfEmail'); const v=email.value.trim();
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)){ email.style.outline='2px solid var(--orange)'; email.focus(); return; }
      email.style.outline='';
      const s=$('.vf-submit'); s.classList.add('loading'); s.textContent='Verifying…';
      // === INTEGRATION POINT: Healthcare ID verification (currently a MOCK) ===
      // Replace this setTimeout with a real verification call (SheerID recommended for
      // NZ & AU healthcare). On a successful verify:
      //   1) SheerID confirms eligibility (country must be NZ or AU, healthcare profession).
      //   2) Your backend mints a UNIQUE, single-use Shopify discount code via the Admin
      //      GraphQL API (discountCodeBasicCreate, 20% off, usage limit 1).
      //   3) Return that code and place it into #vsCodeVal (replace the random code below).
      // See HANDOFF.md → "Healthcare verification" + "Shopify discount codes".
      setTimeout(()=>{
        const code='OSZEA-CARE-'+Math.random().toString(36).slice(2,6).toUpperCase(); // TODO: real code from backend
        $('#vsCodeVal').textContent=code;
        const role=$('#vfRole').value;
        $('#vsSub').innerHTML=`Verified as <b>${role}</b> (${country}). Here's your single-use code for <b>20% off</b>.`;
        form.style.display='none';
        success.setAttribute('aria-hidden','false');
        requestAnimationFrame(()=>success.classList.add('show'));
      }, 1100);
    });
    const codeBtn=$('#vsCode');
    if(codeBtn) codeBtn.addEventListener('click',()=>{
      const val=$('#vsCodeVal').textContent;
      if(navigator.clipboard) navigator.clipboard.writeText(val).catch(()=>{});
      const c=codeBtn.querySelector('.vs-copy'); const old=c.textContent;
      c.textContent='Copied ✓'; codeBtn.classList.add('copied'); toast('Code '+val+' copied');
      setTimeout(()=>{ c.textContent=old; codeBtn.classList.remove('copied'); }, 1800);
    });
  })();

  /* ============ FOOTER accordion (mobile) ============ */
  $$('.foot-col').forEach(col=>{
    const h=$('h4',col);
    if(h) h.addEventListener('click',()=>{ if(window.innerWidth<=560) col.classList.toggle('open'); });
  });

  /* ============ FOOTER water (cursor-reactive) ============ */
  (function initFootWater(){
    const c = document.getElementById('footWater'); if(!c) return;
    const footer = c.closest('.footer'); const ctx = c.getContext('2d');
    let W=0,H=0,dpr=1, ripples=[], mx=-999,my=-999, hot=false, inView=false, running=false, t=0, lastSpawn=0;
    const TEAL = '95,200,194';
    function resize(){ dpr=Math.min(2,window.devicePixelRatio||1); const r=footer.getBoundingClientRect(); W=r.width; H=r.height; c.width=Math.round(W*dpr); c.height=Math.round(H*dpr); ctx.setTransform(dpr,0,0,dpr,0,0); }
    resize(); window.addEventListener('resize', resize, { passive:true });
    function spawn(x,y,s){ ripples.push({ x,y, r:5, max:70*s, a:0.55 }); if(ripples.length>36) ripples.shift(); }
    footer.addEventListener('pointermove', e=>{
      const r=footer.getBoundingClientRect(); mx=e.clientX-r.left; my=e.clientY-r.top; hot=true;
      const now=performance.now(); if(now-lastSpawn>90){ spawn(mx,my,1); lastSpawn=now; }
      start();
    });
    footer.addEventListener('pointerleave', ()=>{ hot=false; });
    footer.addEventListener('pointerdown', e=>{ const r=footer.getBoundingClientRect(); spawn(e.clientX-r.left, e.clientY-r.top, 2.6); start(); });
    function start(){ if(!running){ running=true; requestAnimationFrame(loop); } }
    function loop(){
      t+=0.016; ctx.clearRect(0,0,W,H);
      ctx.globalCompositeOperation='lighter';
      // ambient underwater caustics
      for(let i=0;i<4;i++){
        const x=W*(0.16+0.24*i)+Math.sin(t*0.3+i*1.3)*80;
        const y=H*0.52+Math.cos(t*0.38+i*1.9)*52;
        const rad=150+Math.sin(t*0.5+i)*30;
        const g=ctx.createRadialGradient(x,y,0,x,y,rad);
        g.addColorStop(0,`rgba(${TEAL},0.07)`); g.addColorStop(1,`rgba(${TEAL},0)`);
        ctx.fillStyle=g; ctx.fillRect(0,0,W,H);
      }
      // cursor light pool (gently pulsing)
      if(hot){
        const rad=150+Math.sin(t*3)*14;
        const g=ctx.createRadialGradient(mx,my,0,mx,my,rad);
        g.addColorStop(0,`rgba(${TEAL},0.16)`); g.addColorStop(0.5,`rgba(${TEAL},0.05)`); g.addColorStop(1,`rgba(${TEAL},0)`);
        ctx.fillStyle=g; ctx.fillRect(0,0,W,H);
      }
      ctx.globalCompositeOperation='source-over';
      ripples = ripples.filter(rp=>rp.a>0.012);
      ripples.forEach(rp=>{
        rp.r += (rp.max-rp.r)*0.06; rp.a*=0.955;
        ctx.beginPath(); ctx.arc(rp.x,rp.y,rp.r,0,6.2832);
        ctx.strokeStyle=`rgba(${TEAL},${rp.a})`; ctx.lineWidth=1.6; ctx.stroke();
        ctx.beginPath(); ctx.arc(rp.x,rp.y,rp.r*0.62,0,6.2832);
        ctx.strokeStyle=`rgba(${TEAL},${rp.a*0.5})`; ctx.lineWidth=1.1; ctx.stroke();
        ctx.beginPath(); ctx.arc(rp.x,rp.y,rp.r*0.3,0,6.2832);
        ctx.strokeStyle=`rgba(159,224,220,${rp.a*0.4})`; ctx.lineWidth=0.9; ctx.stroke();
      });
      if(inView || ripples.length){ requestAnimationFrame(loop); } else { running=false; }
    }
    const io=new IntersectionObserver(es=>{ es.forEach(e=>{ inView=e.isIntersecting; if(inView){ resize(); start(); } }); }, { threshold:0.02 });
    io.observe(footer);
  })();

  /* ============ TWEAKS ============ */
  const TW_KEY='oszea_tweaks';
  const tw = Object.assign({ hero:'left', accent:'#3BB0AA', strong:'#2f9e98', rain:30, scrim:100 }, load());
  function load(){ try{ return JSON.parse(localStorage.getItem(TW_KEY))||{}; }catch(e){ return {}; } }
  function save(){ localStorage.setItem(TW_KEY, JSON.stringify(tw)); }
  function applyTweaks(){
    if(tw.hero!=='left' && tw.hero!=='center') tw.hero='left';
    document.body.dataset.hero = tw.hero;
    document.documentElement.style.setProperty('--accent', tw.accent);
    document.documentElement.style.setProperty('--accent-strong', tw.strong);
    document.documentElement.style.setProperty('--rain', (tw.rain/30).toFixed(2));
    document.documentElement.style.setProperty('--hero-scrim', (tw.scrim/100).toFixed(2));
    // sync UI
    $$('#twHero button').forEach(b=>b.classList.toggle('active', b.dataset.hero===tw.hero));
    $$('#twAccent .tw-sw').forEach(b=>b.classList.toggle('active', b.dataset.accent===tw.accent));
    $('#twRain').value=tw.rain; $('#twRainVal').textContent=tw.rain+'%';
    const sc=$('#twScrim'); if(sc){ sc.value=tw.scrim; $('#twScrimVal').textContent=tw.scrim+'%'; }
  }
  $$('#twHero button').forEach(b=>b.addEventListener('click',()=>{ tw.hero=b.dataset.hero; applyTweaks(); save(); }));
  $$('#twAccent .tw-sw').forEach(b=>b.addEventListener('click',()=>{ tw.accent=b.dataset.accent; tw.strong=b.dataset.strong; applyTweaks(); save(); }));
  const twRainEl = $('#twRain');
  if(twRainEl) twRainEl.addEventListener('input',e=>{ tw.rain=+e.target.value; applyTweaks(); save(); });
  const twScrimEl=$('#twScrim'); if(twScrimEl) twScrimEl.addEventListener('input',e=>{ tw.scrim=+e.target.value; applyTweaks(); save(); });
  applyTweaks();

  // host protocol
  const panel=$('#tweaks');
  const tweaksClose = $('#tweaksClose');
  if(tweaksClose && panel) tweaksClose.addEventListener('click',()=>{ panel.classList.remove('open'); window.parent.postMessage({type:'__edit_mode_dismissed'},'*'); });
  window.addEventListener('message',e=>{
    const t=e&&e.data&&e.data.type;
    if(t==='__activate_edit_mode' && panel) panel.classList.add('open');
    else if(t==='__deactivate_edit_mode' && panel) panel.classList.remove('open');
  });
  window.parent.postMessage({type:'__edit_mode_available'},'*');
})();

// --- Newsletter AJAX Submit ---
document.addEventListener('submit', function(e) {
  if (e.target.matches('.js-email')) {
    e.preventDefault();
    var form = e.target;
    var formData = new FormData(form);
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;

    fetch(form.action || '/contact#contact_form', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    }).then(function() {
      var msg = form.querySelector('.fn-msg');
      if (!msg) {
        msg = document.createElement('div');
        msg.className = 'fn-msg success';
        form.appendChild(msg);
      }
      msg.textContent = 'Thanks for subscribing!';
      msg.className = 'fn-msg success';
      msg.style.color = 'var(--teal)';
      
      var input = form.querySelector('input[type="email"]');
      if (input) input.value = '';
    }).catch(function(err) {
      console.error(err);
    }).finally(function() {
      if (btn) btn.disabled = false;
    });
  }
});
